import React, { useEffect, useState } from "react"
import { makeStyles } from "@mui/styles"
import { InputAdornment, Stack, TextField, Typography } from "@mui/material"
import { COLORS, roundNumber } from "../../../utils"
import styled from "@emotion/styled"

const useClasses = makeStyles(() => ({
  banner: {
    backgroundColor: COLORS.BACKGROUND_GREY,
    padding: [14, 32],
    height: 48,
    borderTop: ({ isEdition }) => isEdition ? "1px solid #cccccc" : "1px solid transparent"
  }
}))

export const StyledBannerText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "weight"
})(({ weight = 400 }) => {
  return {
    fontSize: 14,
    fontWeight: weight,
    lineHeight: "22px"
  }
})

const ProductionStepsResumeBanner = ({ foodcost, netWeight, isEdition = false, onNetWeightChange }) => {

  const classes = useClasses({ isEdition })
  const [isNetWeightHovered, setIsNetWeightHovered] = useState(false)
  const [isNetWeightMouseOver, setIsNetWeightMouseOver] = useState(false)
  const [inputValue, setInputValue] = useState("")

  // When the field becomes visible, seed it with the current value (up to 2 decimal places)
  useEffect(() => {
    if (isNetWeightHovered) {
      setInputValue(String(roundNumber(netWeight * 1000, 2)))
    }
  }, [isNetWeightHovered])

  const handleNetWeightChange = (e) => {
    // Allow free typing (including "." and ",") by storing raw string
    setInputValue(e.target.value.replace(",", "."))
  }

  const submitNetWeight = () => {
    const parsed = parseFloat(inputValue)
    if (!isNaN(parsed)) {
      // Use toFixed to avoid float division errors (e.g. 385.56/1000 = 0.38555999...)
      const newNetWeightKg = parseFloat((parsed / 1000).toFixed(10))
      if (roundNumber(parsed, 2) !== roundNumber(netWeight * 1000, 2)) {
        onNetWeightChange && onNetWeightChange(newNetWeightKg)
      }
    }
    setIsNetWeightHovered(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      submitNetWeight()
    } else if (e.key === "Escape") {
      setIsNetWeightHovered(false)
    }
  }

  return (
    <Stack className={classes.banner} direction="row" spacing={2} align="center">
      <Stack direction="row">
        <StyledBannerText weight={500}>
          Foodcost :&nbsp;
        </StyledBannerText>
        <StyledBannerText>
          {roundNumber(foodcost, 3)} €
        </StyledBannerText>
      </Stack>
      <Stack>
        <StyledBannerText>
          /
        </StyledBannerText>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        onClick={() => isEdition && !isNetWeightHovered && setIsNetWeightHovered(true)}
        onMouseEnter={() => isEdition && !isNetWeightHovered && setIsNetWeightMouseOver(true)}
        onMouseLeave={() => setIsNetWeightMouseOver(false)}
        sx={isEdition && !isNetWeightHovered ? { cursor: "pointer" } : {}}
      >
        <StyledBannerText weight={500}>
          Poids net :&nbsp;
        </StyledBannerText>
        {isEdition && isNetWeightHovered ? (
          <TextField
            variant="standard"
            value={inputValue}
            onChange={handleNetWeightChange}
            onBlur={submitNetWeight}
            onKeyDown={handleKeyDown}
            autoFocus
            onFocus={(e) => e.target.select()}
            InputProps={{
              endAdornment: <InputAdornment position="end"><StyledBannerText>g</StyledBannerText></InputAdornment>,
              disableUnderline: true,
            }}
            inputProps={{ inputMode: "decimal", style: { fontSize: 14, fontWeight: 400, width: 60, textAlign: "left", border: "1px solid #474747", borderRadius: 4, padding: "2px 4px" } }}
            sx={{ background: "#fff", borderRadius: 1, p: 0 }}
          />
        ) : (
          <StyledBannerText
            sx={isEdition && isNetWeightMouseOver ? { border: "1px solid #ccc", borderRadius: "4px", padding: "1px 6px", background: "#fff" } : {}}
          >
            {roundNumber(netWeight * 1000, 2)} g
          </StyledBannerText>
        )}
      </Stack>
    </Stack>
  )
}

export default ProductionStepsResumeBanner